import serviceBase from '@/services/serviceBase'
import { ApiBooleanResult, ApiResult } from '@/services/data'

export interface NotificationCount {
  Count: number;
}

export interface InitData {
  Notification: NotificationCount;
}

export interface Device {
  DeviceId: number;
  ClientVersion: string;
  IsOnline: boolean;
  Name: string;
  Started: string;
  DeviceUniqueId: string;
  LastChecked: string;
  ExternalIp: string;
  InternalIp: string;
  Hardwares: Hardware[];
}

export interface Hardware {
  HardwareName: string;
  Identifier: string;
  Properties: SensorProperty[];
  Miner: Miner[];
}

export interface Miner {
  Algorithm: Algorithm;
  MinerClient: MinerClient;
}

export interface Algorithm {
  Algorithm: string;
  HashRate: number;
  Invalid: number;
  Stales: number;
}

export interface MinerClient {
  Name: string;
  UpTimeStr: string;
  Version: string;
}

export interface SensorProperty {
  PropertyType: string;
  ValueStr: string;
  Value: string;
}

export interface HardwareTemperatures {
  HardwareId: string;
  HardwareName: string;
  Temperatures: TemperatureValue[];
}

export interface TemperatureValue {
  Created: string;
  Value: string;
}

export default {
  async getInitData (): Promise<ApiResult<InitData>> {
    return await serviceBase.tryPostResult<InitData>('/data/getInitData')
  },
  async getTemperatures (deviceId: number, groupInterval: string): Promise<ApiResult<HardwareTemperatures[]>> {
    return await serviceBase.tryPostResult<HardwareTemperatures[]>('/device/getPropertyValues', {
      DeviceId: deviceId,
      GroupInterval: groupInterval,
      PropertyType: 'GpuTemp'
    })
  },
  async delDeviceAsync (deviceId: number): Promise<ApiBooleanResult> {
    return await serviceBase.tryPostBooleanResult('/device/delDevice', {
      DeviceId: deviceId
    })
  },
  async rebootDeviceAsync (deviceId: number): Promise<ApiBooleanResult> {
    return await serviceBase.tryPostBooleanResult('/device/rebootDevice', {
      DeviceId: deviceId
    })
  },
  async getGpuFan (deviceId: number, groupInterval: string): Promise<ApiResult<HardwareTemperatures[]>> {
    return await serviceBase.tryPostResult<HardwareTemperatures[]>('/device/getPropertyValues', {
      DeviceId: deviceId,
      GroupInterval: groupInterval,
      PropertyType: 'GpuFanSpeed'
    })
  },
  async getDevicesAsync (deviceId?: number): Promise<ApiResult<Device[]>> {
    return await serviceBase.tryPostResult<Device[]>('/device/getDevices', { deviceId })
  }
}
